import React, { useState, useEffect } from 'react';
import './AddNewBook.css'; // Import the CSS file
import * as Constants from '../../Constant/constant';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import SearchableSelect from '../../shared/SearchableSelect';

function AddNewBook() {
    const [showAddNewBook, setShowAddNewBook] = useState(false);
    const [libraries, setLibraries] = useState([]);
    const [subjectList, setSubjectList] = useState([]);
    const [bookTypes, setBookTypes] = useState([]);
    const [subjectError, setSubjectError] = useState('');
    const [formData, setFormData] = useState({
        library_id: '',
        book_type_id: '',
        num_copies: 1,
        book_code: '',
        procurement_date: '',
        author: '',
        book_name: '',
        series: '',
        edition: '',
        place_of_publication: '',
        publisher: '',
        year_of_publication: '',
        num_pages: '',
        isbn_no: '',
        source: '',
        class_no: '',
        book_no: '',
        call_no: '',
        status: '',
        library_name: '',
        document_category: '',
        almirah: '',
        amount: '',
        book_rack_no: '',
        subject: '',
        procurement_price: '',
        bill_no: '',
        bill_date: '',
        remark: '',
        genre: '',
        publication_type: '',
        version: '',
        recommended_classes: '',
        restricted_classes: '',
        circulation_date: '',
        aging_of_book: '',
        book_location: '',
        catalogue_no: '',
        language_name: '',
        vendor_name: '',
        volume_no: '',
        keywords: '',
        room_no: '',
        shelf_no: '',
        row_no: '',
        image: null 
    });

    // Fetch libraries, subjects, and book types when the component mounts
    useEffect(() => {
        const fetchLibraries = async () => {
            try {
                const response = await fetch(Constants.API_PATH +`/add_new_library_data`); // Replace with your API endpoint
                if (!response.ok) throw new Error('Failed to fetch libraries');
                const data = await response.json();
                setLibraries(data);
            } catch (error) {
                console.error('Error fetching libraries:', error);
            }
        };

        const fetchSubjects = async () => {
            try {
                const response = await fetch(Constants.API_PATH + '/subject-list'); // Replace with your API endpoint
                if (!response.ok) throw new Error('Failed to fetch subjects');
                const data = await response.json();
                setSubjectList(data);
            } catch (error) {
                console.error('Error fetching subjects:', error);
            }
        };

        const fetchBookTypes = async () => {
            try {
                const response = await fetch(Constants.API_PATH +`/book_type_data`); // Replace with your API endpoint
                if (!response.ok) throw new Error('Failed to fetch book types');
                const data = await response.json();
                setBookTypes(data);
            } catch (error) {
                console.error('Error fetching book types:', error);
            }
        };

        fetchLibraries();
        fetchSubjects();
        fetchBookTypes();
    }, []);

    // Function to handle showing the Add New Book section
    const handleAddNewBookClick = () => {
        setShowAddNewBook(true);
    };

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'file' ? files[0] : value,
        }));
    };



    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
            const formDataWithImage = new FormData();
    
            Object.keys(formData).forEach((key) => {
                if (key !== 'image') {
                    formDataWithImage.append(key, formData[key]);
                }
            });
    
            if (formData.image) {
                formDataWithImage.append('image', formData.image);
            }
    
            const response = await fetch(Constants.API_PATH + '/add-books', {
                method: 'POST',
                body: formDataWithImage,
            });
    
            if (!response.ok) {
                throw new Error(`Failed to add new book: ${response.status}`);
            }
    
            // Reset form
            setFormData({
                library_id: '',
                book_type_id: '',
                num_copies: 1,
                book_code: '',
                procurement_date: '',
                author: '',
                book_name: '',
                series: '',
                edition: '',
                place_of_publication: '',
                publisher: '',
                year_of_publication: '',
                num_pages: '',
                isbn_no: '',
                source: '',
                class_no: '',
                book_no: '',
                call_no: '',
                status: '4',
                library_name: '',
                document_category: '',
                almirah: '',
                amount: '',
                book_rack_no: '',
                subject: '',
                procurement_price: '',
                bill_no: '',
                bill_date: '',
                remark: '',
                genre: '',
                publication_type: '',
                version: '',
                recommended_classes: '',
                restricted_classes: '',
                circulation_date: '',
                aging_of_book: '',
                book_location: '',
                catalogue_no: '',
                language_name: '',
                vendor_name: '',
                volume_no: '',
                keywords: '',
                room_no: '',
                shelf_no: '',
                row_no: '',
                image: ''
            });
    
            // SweetAlert success + redirect
            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'New book added successfully!',
                confirmButtonText: 'Go to Book List'
            }).then(() => {
                navigate('/book-list'); // 🔁 update path as per your route
            });
    
        } catch (error) {
            console.error('Error adding new book:', error);
            Swal.fire({
                icon: 'error',
                title: 'Oops!',
                text: 'Failed to add new book. Check console for details.'
            });
        }
    };
    

    return (
        <div className="add-new-book-section containernew">
            <h2 className="section-title">Add New Book</h2>
            <form className="row" onSubmit={handleSubmit}>
                <div className="">
                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="selectLibrary" className="form-label">Select Library*</label>
                        <SearchableSelect
                            id="selectLibrary"
                            name="library_id"
                            value={formData.library_id}
                            onChange={handleChange}
                            options={libraries.map((library) => ({ value: library.id, label: library.library_name }))}
                            placeholder="-Select Library-"
                        />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="selectBookType" className="form-label">Book Type*</label>
                        <SearchableSelect
                            id="selectBookType"
                            name="book_type_id"
                            value={formData.book_type_id}
                            onChange={handleChange}
                            options={bookTypes.map((type) => ({ value: type.id, label: type.book_type_name }))}
                            placeholder="--Select Book Type--"
                        />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="procurementPrice" className="form-label">Procurement Price*</label>
                        <input type="text" id="procurementPrice" className="form-input" name="procurement_price" placeholder="Enter Procurement Price" value={formData.procurement_price} onChange={handleChange} />
                    </div>
                    </div>
                    </div>
                    <div className=''>
                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="noOfCopies" className="form-label ">Count*</label>
                        <input type="number" id="noOfCopies" className="form-input" name="num_copies" defaultValue="1" value={formData.num_copies} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="billNo" className="form-label">Bill No.</label>
                        <input type="text" id="billNo" className="form-input" placeholder="Bill No" name="bill_no" value={formData.bill_no} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="amount" className="form-label">Amount*</label>
                        <input type="text" id="amount" className="form-input" placeholder="Amount" name="amount" value={formData.amount} onChange={handleChange} required />
                    </div>
                    </div>
                    </div>
                    </div>
                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="billDate" className="form-label">Bill Date</label>
                        <input type="date" id="billDate" className="form-input" name="bill_date" value={formData.bill_date} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="procurementDate" className="form-label">Procurement Date (yyyy-mm-dd)*</label>
                        <input type="date" id="procurementDate" className="form-input" name="procurement_date" value={formData.procurement_date} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="remark" className="form-label">Remark*</label>
                        <input type="text" id="remark" className="form-input" placeholder="Enter Remark" name="remark" value={formData.remark} onChange={handleChange} />
                    </div>
                    </div>
                    </div>
                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="authorName" className="form-label">Author*</label>
                        <input type="text" id="authorName" className="form-input" placeholder="Author Name" name="author" value={formData.author} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="genre" className="form-label">Genre*</label>
                        <input type="text" id="genre" className ="form-input" placeholder="Genre" name="genre" value={formData.genre} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="bookName" className="form-label">Book Name*</label>
                        <input type="text" id="bookName" className="form-input" placeholder="Book Name" name="book_name" value={formData.book_name} onChange={handleChange} required />
                    </div>
                    </div>
                    </div>
                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="publicationType" className="form-label">Publication Type</label>
                        <input type="text" id="publicationType" className="form-input" placeholder="Publication Type" name="publication_type" value={formData.publication_type} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="series" className="form-label">Series</label>
                        <input type="text" id="series" className="form-input" placeholder="Series" name="series" value={formData.series} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="version" className="form-label">Version</label>
                        <input type="text" id="version" className="form-input" placeholder="Version" name="version" value={formData.version} onChange={handleChange} />
                    </div>
                    </div>
                    </div>


                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="edition" className="form-label">Edition*</label>
                        <input type="text" id="edition" className="form-input" placeholder="Edition" name="edition" value={formData.edition} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="placeOfPublication" className="form-label">Place of Publication*</label>
                        <input type="text" id="placeOfPublication" className="form-input" placeholder="Place of Publication" name="place_of_publication" value={formData.place_of_publication} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="publisher" className="form-label">Publisher*</label>
                        <input type="text" id="publisher" className="form-input" placeholder="Publisher" name="publisher" value={formData.publisher} onChange={handleChange} />
                    </div>
                    </div>
                    </div>

                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
  <label htmlFor="yearOfPublication" className="form-label">Year of Publication*</label>
  <SearchableSelect
    id="yearOfPublication"
    name="year_of_publication"
    value={formData.year_of_publication}
    onChange={handleChange}
    options={Array.from({ length: 50 }, (_, i) => {
      const year = new Date().getFullYear() - i;
      return { value: year, label: year };
    })}
    placeholder="Select Year"
  />
</div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
  <label htmlFor="noOfPages" className="form-label">No. Of Pages*</label>
  <input
    type="number"
    id="noOfPages"
    className="form-input"
    placeholder="Number of pages"
    name="num_pages"
    value={formData.num_pages}
    onChange={handleChange}
    min="1"
  />
</div>

                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="isbnNo" className="form-label">ISBN No.*</label>
                        <input type="text" id="isbnNo" className="form-input" placeholder="ISBN No" name="isbn_no" value={formData.isbn_no} onChange={handleChange} />
                    </div>
                    </div>
                    </div>

                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="source" className="form-label">Source*</label>
                        <input type="text" id="source" className="form-input" placeholder="Enter Supplier" name="source" value={formData.source} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="vendorName" className="form-label">Vendor Name*</label>
                        <input type="text" id="vendorName" className="form-input" placeholder="Vendor Name" name="vendor_name" value={formData.vendor_name} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="classNo " className="form-label">Class No.*</label>
                        <input type="text" id="classNo" className="form-input" placeholder="Class No" name="class_no" value={formData.class_no} onChange={handleChange} />
                    </div>
                    </div>
                    </div>


                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="volumeNo" className="form-label">Volume No</label>
                        <input type="text" id="volumeNo" className="form-input" placeholder="Volume No" name="volume_no" value={formData.volume_no} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="bookNo" className="form-label">Book No.*</label>
                        <input type="text" id="bookNo" className="form-input" placeholder="Book No" name="book_no" value={formData.book_no} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="keywords" className="form-label">Keywords*</label>
                        <input type="text" id="keywords" className="form-input" placeholder="Keywords" name="keywords" value={formData.keywords} onChange={handleChange} />
                    </div>
                    </div>
                    </div>


                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="callNo" className="form-label">Call No.*</label>
                        <input type="text" id="callNo" className="form-input" placeholder="Call No" name="call_no" value={formData.call_no} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="roomNo" className="form-label">Room No</label>
                        <input type="text" id="roomNo" className="form-input" placeholder="Room No" name="room_no" value={formData.room_no} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="circulationDate" className="form-label">Circulation Date (dd-mm-yyyy)*</label>
                        <input type="date" id="circulationDate" className="form-input" name="circulation_date" value={formData.circulation_date} onChange={handleChange} />
                    </div>
                    </div>
                    </div>


                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="ageOfBook" className="form-label">Aging Of Book</label>
                        <input type="number" id="ageOfBook" className="form-input" placeholder="Aging Of Book" name="aging_of_book" value={formData.aging_of_book} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="bookLocation" className="form-label">Book Location</label>
                        <input type="text" id="bookLocation" className="form-input" placeholder="Book Location" name="book_location" value={formData.book_location} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="catalogueNo" className="form-label">Catalogue No</label>
                        <input type="text" id="catalogueNo" className="form-input" placeholder="Catalogue No" name="catalogue_no" value={formData.catalogue_no} onChange={handleChange} />
                    </div>
                    </div>
                    </div>

                    <div className='row'>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="languageName" className="form-label">Language Name*</label>
                        <input type="text" id="languageName" className="form-input" placeholder="Language Name" name="language_name" value={formData.language_name} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="shelfNo" className="form-label">Shelf No*</label>
                        <input type="text" id="shelfNo" className="form-input" placeholder="Shelf No" name="shelf_no" value={formData.shelf_no} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="documentCategory" className="form-label">Document Category*</label>
                        <input type="text" id="documentCategory" className="form-input" placeholder="Document Category" name="document_category" value={formData.document_category} onChange={handleChange} />
                    </div>
                    </div>
                    </div>


                    <div className='row'>
                        
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="rowNo" className="form-label">Row No</label>
                        <input type="text" id="rowNo" className="form-input" placeholder="Row No" name="row_no" value={formData.row_no} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="almirah" className="form-label">Almirah*</label>
                        <input type="text" id="almirah" className="form-input" placeholder="Almirah" name="almirah" value={formData.almirah} onChange={handleChange} />
                    </div>
                    </div>
                    <div className='col-md-4'>
                    <div className="form-group">
                        <label htmlFor="bookRackNo" className="form-label">Book Rack No</label>
                        <input type="text" id="bookRackNo" className="form-input" placeholder="Book Rack No" name="book_rack_no" value={formData.book_rack_no} onChange={handleChange} />
                    </div>
                    </div>
                    </div>
                    <div className='row'>
                    <div className="form-group">
                        {/* <label htmlFor="image" className="form-label">Upload Image</label>
                        <input type="file" id="image" className="form-input" name="image" accept="image/*" onChange={handleChange} /> */}
                        <div className="form-group">
                        <label htmlFor="image" className="form-label">Upload Image*</label>
                        <input
                            type="file"
                            id="image"
                            className="form-input"
                            name="image"
                            accept="image/*"
                            onChange={handleChange}
                        />
                    </div>

                    {/* ✅ Preview Image */}
                    {formData.image && (
                        <div className="form-group">
                            <p>Image Preview:</p>
                            <img
                                src={URL.createObjectURL(formData.image)}
                                alt="Preview"
                                style={{ maxWidth: '200px', marginTop: '10px' }}
                            />
                        </div>
                    )}
                
                    </div>
                    </div>
                </div>
                <button type="submit" className="submit-button">Submit</button>
            </form>
        </div>
    );
}

export default AddNewBook;